/**
 * @generated SignedSource<<a5ab268a870f77b6e63d14f214893b3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RightFrameContentElement_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly currentElementState?: {
      readonly element: {
        readonly elementType: ElementTypeV2;
      };
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"FileElementPart_ContentSubmissionFragment" | "PodcastElementPart_ContentSubmissionFragment" | "RightFrameMultipleChoiceElementPart_ContentSubmissionFragment" | "TextElementPart_ContentSubmissionFragment" | "VideoElementPart_ContentSubmissionFragment">;
  readonly " $fragmentType": "RightFrameContentElement_ContentSubmissionFragment";
};
export type RightFrameContentElement_ContentSubmissionFragment$key = {
  readonly " $data"?: RightFrameContentElement_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RightFrameContentElement_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RightFrameContentElement_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "currentElementState",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "element",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elementType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ActiveELearningContentSubmissionDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RightFrameMultipleChoiceElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PodcastElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TextElementPart_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VideoElementPart_ContentSubmissionFragment"
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "e0145efc7f46f3f795f3aba40bf83396";

export default node;
